import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { CloudDownloadOutlined, RefreshRounded } from "@material-ui/icons";
import api from "../../../services/api";
import CircularLoader from "../../UI/Loader";
import WithdrawalRequestsTable from "./WithdrawalRequestsTable";
import { IconButton } from "@material-ui/core";
function WithdrawalRequests() {
  const [customers, setCustomers] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getWithdrawRequests();
  }, []);
  async function getWithdrawRequests() {
    try {
      setLoading(true);
      const response = await api.get("admin/withdraw-requests");
      if (response.status == 200) {
        setLoading(false);
        setCustomers(response.data.data);
      }
    } catch (error) {
      setLoading(false);
    }
  }
  return (
    <CustomerWrapper>
      <div className="customer-nav">
        <Nav>
          <NavContainer>
            <NavLogo>
              <Typography>Withdrawal Requests</Typography>
            </NavLogo>
            <NavMenu>
              <NavMenuItem>
                <IconButton>
                  <RefreshRounded style={{ color: "white" }} />
                </IconButton>
              </NavMenuItem>
              <IconButton>
                <CloudDownloadOutlined style={{ color: "white" }} />
              </IconButton>
            </NavMenu>
          </NavContainer>
        </Nav>
      </div>
      <div className="customer">
        {loading ? (
          <CircularLoader isLoading={loading} />
        ) : (
          <WithdrawalRequestsTable
            customers={customers}
            getWithdrawRequests={getWithdrawRequests}
          />
        )}
      </div>
    </CustomerWrapper>
  );
}

export default WithdrawalRequests;
const CustomerWrapper = styled.div`
  width: 100%;
  background: white;
  padding: 1rem;
  border-radius: 4px;
  height: 100%;
  .customer {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    margin-top: 1rem;
  }
`;
const Nav = styled.nav`
  // background-color: #f4f6fb;
  color: #fff;
  padding: 1rem;
  color: white;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    rgb(7 30 28) 0%,
    rgba(5, 71, 82, 1) 60%,
    rgb(23 104 120) 100%
  );
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const NavLogo = styled.div`
  font-size: 2.5rem;
  color: #054752;
  display: flex;
  text-align: center;
  align-items: center;
  gap: 2rem;
`;

const NavMenu = styled.ul`
  list-style: none;
  display: flex;
`;

const NavMenuItem = styled.li`
  font-size: 1.5rem;
  color: #054752;
`;
const Typography = styled.div`
  font-family: sans-serif;
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
`;
